import { TimelineEntryDto } from '@app/models/dtos/contentDto';

/** One line per year. Keep them concrete — a claim beats an adjective. */
const timeline: TimelineEntryDto[] = [
    { year: '2018', text: 'Started a B.E. in Computer Engineering at Khwopa College, Bhaktapur.' },
    { year: '2020', text: 'First production code. Flutter apps at Smart Robos, India, while still studying.' },
    { year: '2021', text: 'Joined Sireto Technology. Five products shipped across web, mobile and Web3, and four interns mentored.' },
    { year: '2022', text: 'Graduated. Built Cardano Test Wallet, and contributed to Sancho GovTool with IntersectMBO.' },
    { year: '2024', text: 'Senior Software Engineer at Whitehat Engineering, architecting an AI movie generation platform end to end.' },
    { year: 'Now', text: 'Still at Whitehat, still on the same platform. The work now is making long renders survive whatever goes wrong in the middle of them.' }
];

export default timeline;
